import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Card, Carousel } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css'; // Import Bootstrap CSS
import './Classes.css'; // Import the CSS file

const Classes = () => {
  const [isMobile, setIsMobile] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0); // Track the active carousel index

  // Check if the screen size is mobile
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768); // Mobile view for screens <= 768px
    };

    handleResize(); // Initial check
    window.addEventListener('resize', handleResize); // Add resize listener

    return () => window.removeEventListener('resize', handleResize); // Cleanup listener
  }, []);

  // Map class links to carousel indices
  const classLinks = [
    { id: 'muay-thai', label: 'Muay Thai', index: 0 },
    { id: 'taekwondo', label: 'Taekwondo', index: 1 },
    { id: 'jiu-jitsu', label: 'Jiu-Jitsu', index: 2 },
    { id: 'wrestling', label: 'Wrestling', index: 3 },
    { id: 'personal-training', label: 'Personal Training', index: 4 },
    { id: 'kids-program', label: 'Kids Program', index: 5 },
  ];

  return (
    <div className="classes-wrapper">
      <Container fluid className="classes-container">
        {isMobile ? (
          <>
            {/* Link Menu for Mobile View */}
            <div className="class-links">
              {classLinks.map((link) => (
                <a
                  key={link.id}
                  href={`#${link.id}`}
                  className={`class-link ${activeIndex === link.index ? 'active' : ''}`} // Highlight active link
                  onClick={(e) => {
                    e.preventDefault(); // Prevent default anchor behavior
                    setActiveIndex(link.index); // Set the carousel to the corresponding index
                  }}
                >
                  {link.label}
                </a>
              ))}
            </div>

            {/* Mobile View: Carousel */}
            <Carousel
              activeIndex={activeIndex} // Bind the active index to the carousel
              onSelect={(selectedIndex) => setActiveIndex(selectedIndex)} // Update the active index when the carousel changes
            >
              <Carousel.Item>
                <Card className="class-card" style={{ backgroundImage: 'url(/assets/images/rami-mobile-cover.jpeg)', backgroundSize: 'cover', backgroundPosition: 'center' }}>
                  <Card.Body>
                    <Card.Title>Muay Thai</Card.Title>
                  </Card.Body>
                </Card>
              </Carousel.Item>
              <Carousel.Item>
                <Card className="class-card" style={{ backgroundImage: 'url(/assets/images/rami-elite-taekwondo.png)', backgroundSize: 'cover', backgroundPosition: 'center' }}>
                  <Card.Body>
                    <Card.Title>Taekwondo</Card.Title>
                  </Card.Body>
                </Card>
                </Carousel.Item>
                <Carousel.Item>
                <Card className="class-card" style={{ backgroundImage: 'url(/assets/images/rami-elite-jiu-jitsu.JPEG)', backgroundSize: 'cover', backgroundPosition: 'center' }}>
                  <Card.Body>
                    <Card.Title>Jiu-Jitsu</Card.Title>
                  </Card.Body>
                </Card>
                </Carousel.Item>
                <Carousel.Item>
                <Card className="class-card" style={{ backgroundImage: 'url(/assets/images/rami-elite-wrestling.JPEG)', backgroundSize: 'cover', backgroundPosition: 'center' }}>
                  <Card.Body>
                    <Card.Title>Wrestling</Card.Title>
                  </Card.Body>
                </Card>
                </Carousel.Item>
                <Carousel.Item>
                <Card className="class-card" style={{ backgroundImage: 'url(/assets/images/rami-elite-personal-training.JPEG)', backgroundSize: 'cover', backgroundPosition: 'center' }}>
                  <Card.Body>
                    <Card.Title>Personal Traning</Card.Title>
                  </Card.Body>
                </Card>
                </Carousel.Item>
                <Carousel.Item>
                <Card className="class-card" style={{ backgroundImage: 'url(/assets/images/rami-elite-kids-program.JPEG)', backgroundSize: 'cover', backgroundPosition: 'center' }}>
                  <Card.Body>
                    <Card.Title>Kids Program</Card.Title>
                  </Card.Body>
                </Card>
                </Carousel.Item>
            </Carousel>
            
          </>
        ) : (
          // Desktop View: Original Layout
          <>
            <Row className="no-gutters">
              <Col xs={12} md={4} id="muay-thai">
                <Card className="class-card" style={{ backgroundImage: 'url(/assets/images/rami-mobile-cover.jpeg)', backgroundSize: 'cover', backgroundPosition: 'center' }}>
                  <Card.Body>
                    <Card.Title>Muay Thai</Card.Title>
                  </Card.Body>
                </Card>
              </Col>
              <Col xs={12} md={4} id="taekwondo">
                <Card className="class-card" style={{ backgroundImage: 'url(/assets/images/rami-elite-taekwondo.png)', backgroundSize: 'cover', backgroundPosition: 'center' }}>
                  <Card.Body>
                    <Card.Title>Taekwondo</Card.Title>
                  </Card.Body>
                </Card>
              </Col>
              <Col xs={12} md={4} id="jiu-jitsu">
                <Card className="class-card" style={{ backgroundImage: 'url(/assets/images/rami-elite-jiu-jitsu.JPEG)', backgroundSize: 'cover', backgroundPosition: 'center' }} >
                  <Card.Body>
                    <Card.Title>Jiu-Jitsu</Card.Title>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
            {/* Second Row */}
            <Row className="no-gutters">
              <Col xs={12} md={4} id="wrestling">
                <Card className="class-card" style={{ backgroundImage: 'url(/assets/images/rami-elite-wrestling.JPEG)', backgroundSize: 'cover', backgroundPosition: 'center' }}>
                  <Card.Body>
                    <Card.Title>Wrestling</Card.Title>
                  </Card.Body>
                </Card>
              </Col>
              <Col xs={12} md={4} id="personal-training">
                <Card className="class-card" style={{ backgroundImage: 'url(/assets/images/rami-elite-personal-training.JPEG', backgroundSize: 'cover', backgroundPosition: 'center' }}>
                  <Card.Body>
                    <Card.Title>Personal Training</Card.Title>
                  </Card.Body>
                </Card>
              </Col>
              <Col xs={12} md={4} id="kids-program">
                <Card className="class-card" style={{ backgroundImage: 'url(/assets/images/rami-elite-kids-program.JPEG)', backgroundSize: 'cover', backgroundPosition: 'center' }}>
                  <Card.Body>
                    <Card.Title>Kids Program</Card.Title>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </>
        )}
      </Container>
    </div>
 
  );
};

export default Classes;